import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export function scrollPageTo(element, options = {}) {
    if (!element) {
        WEBUILogs.error("Missing DOM element for scrollTo action");
        return Promise.reject();
    }
    // Calculate the fixed header size, by getting the top value of the viewport, which in this case,
    // is the height of the fixed header. In addition, because the top property of the,
    // object returned form the getBoundingClientRect() varies depending on the scroll,
    // the top scroll of the document is been added to the top value we calculated from the viewport.
    let fixedHeaderSize = Math.abs(
        document.body.getBoundingClientRect().top + document.documentElement.scrollTop
    );

    // Scroll element into view.
    const offsetX = options.offsetX || 0;
    const offsetY = options.offsetY || 0;
    const elementX = (
        element.getBoundingClientRect().left + document.documentElement.scrollLeft
    ).toFixed(0);
    const elementY = (
        element.getBoundingClientRect().top + document.documentElement.scrollTop
    ).toFixed(0);

    if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo(
            Object.assign(
                {
                    top: elementY - offsetY,
                    left: elementX - offsetX
                },
                options
            )
        );
    } else {
        window.scrollTo(elementX - offsetX, elementY - offsetY);
    }

    // Calculate if the element, the page is scrolling to, is a part of the viewport.
    let docViewTop = document.documentElement.scrollTop;
    let docViewBottom = docViewTop + window.innerHeight;
    let elemTop = element.offsetTop;
    let elemBottom = elemTop + element.offsetHeight;
    let isElementInViewport = elemBottom <= docViewBottom && elemTop >= docViewTop;

    // Calculate if the body is scrolled to the bottom of the document.
    let bodyElementBottomScroll = window.innerHeight + window.scrollY >= document.body.scrollHeight;

    // The document will scroll to the bottom if the calculation for body bottom scrolling returns true and,
    // the calculation of the element in the viewport is true.
    if (bodyElementBottomScroll && isElementInViewport) {
        window.scrollTo(0, document.body.scrollHeight);
    } else if (fixedHeaderSize && !isElementInViewport) {
        // If not the document scroll top is decresed with the fixed header size + 10 additional pixels for spacing.
        document.documentElement.scrollTop -= fixedHeaderSize + 10;
    }
}

export function scrollElementTo(listContainer, element) {
    //Presumption: listContainer has a list of items each containing one uniqueContainer element
    //using element.parentNode to avoid issues with custom css for listContainer's item elements
    listContainer.scrollTop = element.parentNode.offsetTop;
}

//searching for uniqueId property, returning the first match
export function getDOMElementByEntityId(uniqueId = "") {
    let result = document.querySelector(`[data-unique-id="${uniqueId}"]`);
    if (!result) {
        WEBUILogs.error("Missing DOM element for: " + uniqueId);
    }
    return result;
}
